import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  List,
  Datagrid,
  TextField,
  ShowButton,
  EditButton,
  DeleteWithConfirmButton,
} from 'react-admin';
import filters from '../../../components/integration/functions/filters';
import ListActions from '../../../components/commons/listActions';
import PostPagination from '../../../components/commons/postPagination';
import PostBulkActionButtons from '../../../components/commons/postBulkActionButtons';
import canAccess from '../../../utils/canAccess';
import FUNC from '../../../utils/functions';

export default React.memo(() => {
  const { permissions } = useSelector((state: any) => state.app.appState);
  const canPut = canAccess(permissions, FUNC.EDIT_FUNCTION);
  const canDelete = canAccess(permissions, FUNC.DELETE_FUNCTION);
  const canPost = canAccess(permissions, FUNC.ADD_FUNCTION);
  const canShow = canAccess(permissions, FUNC.SHOW_FUNCTION_DETAIL);
  return (
    <List
      filters={filters}
      actions={<ListActions isExport isCreate={canPost} />}
      pagination={<PostPagination />}
      perPage={100}
    >
      <Datagrid bulkActionButtons={<PostBulkActionButtons />} optimized>
        <TextField source="showId" />
        <TextField source="moduleId" />
        <TextField source="functionCode" />
        <TextField source="name" />
        <TextField source="area" />
        <TextField source="controller" />
        <TextField source="action" />
        {canShow && <ShowButton label="" />}
        {canPut && <EditButton label="" />}
        {canDelete && <DeleteWithConfirmButton label="" mutationMode="pessimistic" />}
      </Datagrid>
    </List>
  );
});
